import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class GlobalCacheService {
  private cache = new Map<string, any>();
  private maxEntries = 200;

  get(key: string): any {
    return this.cache.get(key);
  }

  set(key: string, value: any): void {
    if (this.cache.size >= this.maxEntries) {
      // Elimina la entrada más antigua
      const oldestKey = this.cache.keys().next().value;
      if (typeof oldestKey === 'string') {
        this.cache.delete(oldestKey);
      }
    }
    this.cache.set(key, value);
  }

  clear(key?: string): void {
    if (key) {
      this.cache.delete(key);
    } else {
      this.cache.clear();
    }
  }
}
